import styled from '@emotion/styled';
import { CoachAvatar } from '@features/coaches/coachCard/coachAvatar/ui';
import { SDescription, SName, SSpecialization } from '@features/coaches/coachCard/coacheStyledComponents';
import * as main from '@shared/styles/abstracts/vars.module.scss';
import { SMagicBox } from '@shared/styles/styledComponentsCommon.ts';
import { Card } from '@shared/ui/index';

export const SCard = styled(Card)`
  padding: 20px;
  max-width: 1140px;
  font-family: Roboto, sans-serif;
  @media (width < ${main.brpMobileL}) {
    background-color: inherit;
    box-shadow: none;
    padding: 0;
  }
`;
export const STitle = styled(SMagicBox)`
  z-index: 1;
  position: relative;

  font-size: ${main.fontBetweenLargeMedium};
  color: ${main.colorTextPrimary};
  font-weight: 400;
  //line-height: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
  font-family: Roboto, sans-serif;
  @media (width < ${main.brpMobileL}) {
    font-size: 24px;
    line-height: 28px;
    text-align: left;
  }
`;

export const SContactsTitle = styled(STitle)`
  margin-bottom: 20px;
`;

export const SPhotoAndDescription = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 22px;
  @media (width < ${main.brpMobileL}) {
    flex-direction: column;
    margin-bottom: 25px;
  }
`;

export const SSSpecialization = styled(SSpecialization)`
  margin-top: 10px;
  font-size: ${main.fontBetweenLargeMedium};
  @media (width < ${main.brpMobileL}) {
    margin-top: 0;
    font-size: 18px;
  }
  line-height: 20px;
  text-overflow: unset;
  white-space: wrap;
  max-width: 100% !important;
`;
export const SSName = styled(SName)`
  line-height: 28px;
  font-size: ${main.fontBetweenLargestLarge};
  max-width: 100% !important;
  max-height: none;
  @media (width < ${main.brpMobileL}) {
    font-size: ${main.fontLargestMobile};
    line-height: 36px;
  }
`;
export const SNameAndSpecialization = styled(SDescription)`
  z-index: 1;
  position: relative;
  margin-left: 20px;
  margin-top: 3px;
  @media (width < ${main.brpMobileL}) {
    order: 0;
    gap: 20px;
    margin-top: 0;
    margin-left: 0;
    margin-bottom: 25px;
    width: 100%;
  }
`;
export const SCoachAvatarLargeContainer = styled.div`
  position: relative;
  z-index: 0;

  @media (width < ${main.brpMobileL}) {
    order: 1;
  }
`;

export const SCoachAvatar = styled(CoachAvatar)`
  width: 250px;
  height: 250px;

  img {
    width: 100%;
    height: 100%;
  }

  @media (width < ${main.brpMobileL}) {
    width: calc(100vw - 40px);
    height: calc(100vw - 40px);
    margin: 0 auto;
  }

  a {
    width: 44px;
    height: 44px;
    border: none;
    border-radius: 6px;
    background: rgba(22, 23, 24, 0.3);
    position: absolute;

    margin-left: 15px;
    bottom: 15px;
    display: flex;
    align-items: center;

    svg {
      margin: 0 auto;
      width: 20px;
      height: 20px;
      position: static;
      transform: none;
      color: white;

      path {
        transform: none;
        fill: white;
      }
    }
  }
`;
